var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff200;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.64,16.27c0-1.04,.28-2.02,.85-2.95s1.4-1.66,2.5-2.21,2.38-.83,3.85-.83c1.24,0,2.33,.16,3.27,.48s1.72,.77,2.34,1.34,1.09,1.21,1.39,1.92,.45,1.47,.45,2.27c0,1.02-.27,1.93-.79,2.73s-1.31,1.46-2.35,1.97c.88,.34,1.62,.79,2.2,1.35s1.02,1.2,1.32,1.94,.45,1.55,.45,2.45c0,1.31-.32,2.5-.95,3.57s-1.57,1.9-2.8,2.51-2.68,.91-4.34,.91-3.21-.3-4.44-.91-2.16-1.43-2.78-2.49-.94-2.24-.94-3.55c0-2.8,1.32-4.72,3.97-5.77-2.13-1-3.2-2.58-3.2-4.73Zm11.2,10.34c0-.81-.16-1.52-.5-2.12s-.8-1.07-1.41-1.39-1.28-.48-2.03-.48c-1.06,0-1.95,.36-2.67,1.06s-1.08,1.7-1.08,2.97c0,.81,.17,1.53,.51,2.15s.8,1.1,1.38,1.44,1.23,.51,1.95,.51,1.38-.17,1.97-.52,1.04-.83,1.38-1.45,.5-1.34,.5-2.16Zm-3.91-13.34c-.98,0-1.77,.3-2.37,.91s-.9,1.39-.9,2.35c0,.89,.3,1.62,.92,2.21s1.41,.88,2.38,.88c.49,0,.94-.08,1.34-.23s.74-.37,1.03-.65,.51-.61,.66-.98,.23-.8,.23-1.26c0-.61-.14-1.17-.41-1.66s-.66-.88-1.16-1.16-1.07-.42-1.72-.42Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt8);
export default __webpack_public_path__ + "static/media/CT8.14258133fa20303280e51befb261a281.svg";
export { ForwardRef as ReactComponent };